import React, { useEffect, useState } from "react";
import { CircularProgress, Box } from '@mui/material';
// import * as XLSX from 'xlsx';
import { csvParse } from "d3";
import { useDispatch } from "react-redux";
import { logout } from "../features/userSlice";
import { useContextStateManagement } from "../context/ContextApi";
import PriorAuthQBulkUploadLead from "../assets/bulkUploadLeadFiles/PriorAuthQBulkUploadLead.csv";
import LeadGenerationBulkUploadLead from "../assets/bulkUploadLeadFiles/LeadGenerationBulkUploadLead.csv";
import { getUserLicenseDetails, currentMemberListName } from "../Variables";
import { useNavigate } from "react-router-dom";

const REQUIRED_COLUMNS_BY_TAB = {
    inBoundCalls: [
        "PatientFullName",
        "PatientDateOfBirth",
        "PatientContactNumber",
        "PatientEmailAddress",
        "PatientInsuranceProvider",
        "PatientInsuranceIdNumber",
        "PatientInsuranceContactNumber",
        "ProcedureCPT_codes",
        "ProcedureICD_diagnosisCode",
        "ProcedureDescription",
        "ICD_descriptions",
    ],
    leadGTab: ["PatientFullName", "PatientContactNumber"],
};

export const BulkUploadLead = ({ outBoundLeadsDetail, setOutBoundLeadsDetail }) => {
    const [file, setFile] = useState();
    const [previewColumns, setPreviewColumns] = useState([]);
    const [previewRows, setPreviewRows] = useState([]);
    const [previewTotalRows, setPreviewTotalRows] = useState(0);
    const [previewMissingColumns, setPreviewMissingColumns] = useState([]);
    const [previewError, setPreviewError] = useState("");
    const [providerData, setProviderData] = useState([]);
    const [loadingEnable, setLoadingEnable] = useState(false);
    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [dataSubmitted, setDataSubmitted] = useState(false);
    const [providerId, setProviderId] = useState("");
    const [lesdsUploadMessage, setLesdsUploadMessage] = useState("");
    const [isData, setIsData] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { PracticeId, activeTab, setSideBarLinkActive, token, setToken, fetchUserRecord, activeOnBoardingTem, usersPostRequest, setDateUrl, setUserType, userType } = useContextStateManagement();

    const fetchApiHandle = async () => {
        // setLesdsUploadMessage("");
        let url;
        if (activeTab === "inBoundCalls") {
            url = `/api/PAuthQOnBoardingTemplate/${PracticeId}`
        }
        else if (activeTab === "leadGTab") {
            url = `/api/LeadGenerationOnboarding/${PracticeId}`;
        }
        else if (activeTab === "uatTab") {
            setDateUrl(`/api/SearchDateUatTest`);
        }

        if (!url) {
            setProviderData([]);
            setIsData(false);
            return;
        }

        const userData = await fetchUserRecord(token, url);
        if (userData == "Token is expired, login again") {
            setIsTokenExpired(true)
        }
        else if (userData) {
            if ((activeTab === "inBoundCalls") || (activeTab === "leadGTab")) {
                if (userData.providersData) {
                    setProviderData(userData.providersData)
                    setIsData(true)
                }
            }
            else {
                setProviderData(userData)
                setIsData(true)
            }
        }
    }

    // const setErrorMsgs = () => {
    //     debugger
    //     let leadsAllowed = 0;
    //     let memberListName = currentMemberListName(activeTab);
    //     leadsAllowed = userType !== "admin" && outBoundLeadsDetail && outBoundLeadsDetail.LicenseType !== "subscription" ? outBoundLeadsDetail.LeadsAllowed - parseInt(outBoundLeadsDetail[memberListName]) : "";

    //     if (providerData.length === 0 && isData === true && userType !== "admin") {
    //         setLesdsUploadMessage("No provider added, Please contact admin to add provider first then you can add/upload leads");
    //         // setIsData(false)
    //     }

    //     if (providerData.length > 0 && isData === true && userType !== "admin" && leadsAllowed !== "" && !leadsAllowed <= 0) {
    //         setLesdsUploadMessage("You can upload only 10 leads on trial !");
    //         // setIsData(false)
    //     }
    //     setIsData(false)

    // }

    // useEffect(() => {
    //     debugger
    //     if (isData === true && userType !== "admin") {
    //         setErrorMsgs()
    //     }
    // }, [isData]);

    useEffect(() => {
        if (activeTab || PracticeId && userType === "admin") {
            fetchApiHandle();
            // setLesdsUploadMessage("");
        }
    }, [activeTab, PracticeId])

    // const fileReader = new FileReader();

    const buildPreview = async (selectedFile) => {
        setPreviewError("");
        setPreviewColumns([]);
        setPreviewRows([]);
        setPreviewTotalRows(0);
        setPreviewMissingColumns([]);

        if (!selectedFile) return;

        try {
            const text = await selectedFile.text();
            const rows = csvParse(text);
            const columns = rows.columns || (rows[0] ? Object.keys(rows[0]) : []);
            const requiredColumns = REQUIRED_COLUMNS_BY_TAB[activeTab] || [];

            setPreviewColumns(columns);
            setPreviewRows(rows.slice(0, 10));
            setPreviewTotalRows(rows.length);
            setPreviewMissingColumns(requiredColumns.filter((col) => !columns.includes(col)));
        } catch (error) {
            setPreviewError("Could not read this file as CSV.");
        }
    };

    let handleOnChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        document.getElementById('submitBulkUpload').removeAttribute("disabled");
        buildPreview(selectedFile);
    }

    const parseCsvValue = (value) => {
        const trimmedValue = value.trim();

        if (trimmedValue === "") {
            return "";
        }

        if (/^(true|false)$/i.test(trimmedValue)) {
            return trimmedValue.toLowerCase() === "true";
        }

        if (/^-?\d+(\.\d+)?$/.test(trimmedValue)) {
            return Number(trimmedValue);
        }

        return trimmedValue;
    };

    const hasRequiredOutboundColumns = (row) =>
        row &&
        ["PatientFullName", "PatientContactNumber"].every((field) =>
            Object.prototype.hasOwnProperty.call(row, field)
        );

    const csvFileToArray = async (file) => {
        let memberListName = currentMemberListName(activeTab);
        let leadsAllowed = outBoundLeadsDetail !== undefined && outBoundLeadsDetail.LicenseType == "trial" && userType !== "admin" ? outBoundLeadsDetail.LeadsAllowed - parseInt(outBoundLeadsDetail[memberListName]) : "";
        let leadsArray;
        setLoadingEnable(true)
        try {
            const text = await file.text();
            leadsArray = csvParse(text, (row) => {
                const parsedRow = {};

                Object.entries(row).forEach(([key, value]) => {
                    parsedRow[key] = parseCsvValue(value);
                });

                return parsedRow;
            });

            leadsArray = leadsArray.filter(row => {
                const values = Array.isArray(row) ? row : Object.values(row);
                return values.every(cell => cell && cell.toString().trim() !== "");
            });

            let selectedProviderData = providerData.filter((getProvider) => {
                setProviderId("");
                return getProvider.Id == providerId;
            })

            if (activeTab == "inBoundCalls") {
                for (const obj of leadsArray) {
                    obj.PatientContactNumber = obj.PatientContactNumber;
                    obj.PatientInsuranceContactNumber = obj.PatientInsuranceContactNumber;
                    obj.PracticeId = PracticeId;
                    obj.ProviderId = selectedProviderData[0].Id;
                    obj.ProviderName = selectedProviderData[0].ProviderName;
                    obj.ProviderFacilityName = selectedProviderData[0].ProviderFacilityName;
                    obj.NationalProviderIdentifier = selectedProviderData[0].NationalProviderIdentifier;
                    obj.ProviderContactNumber = selectedProviderData[0].ProviderContactNumber;
                    obj.ProviderFaxNumber = selectedProviderData[0].ProviderFaxNumber;
                    obj.ProviderEmailAddress = selectedProviderData[0].ProviderEmailAddress;
                }

                if (Object.keys(leadsArray[0]).length === 19) {
                    let url = "/api/PriorAuthQLead";
                    const userData = await usersPostRequest(token, url, leadsArray);
                    if (userData == "Token is expired, login again") {
                        setIsTokenExpired(true);
                        return
                    }
                    else if (userData && userData.message) {
                        setDataSubmitted(true);
                    } else {
                        setDataSubmitted(false);
                        return
                    }

                } else {
                    alert("Invalid file data")
                    setLoadingEnable(false)
                    document.getElementById("selected_ProviderId").value = "";
                    return
                }

            } else if (activeTab == "leadGTab") {
                for (const obj of leadsArray) {
                    obj.PatientContactNumber = obj.PatientContactNumber;
                    obj.PracticeId = PracticeId;
                    obj.ProviderId = selectedProviderData[0].Id;
                    obj.ProviderName = selectedProviderData[0].ProviderName;
                    obj.ProviderFacilityName = selectedProviderData[0].ProviderFacilityName;
                    obj.ProviderSpecialtyType = selectedProviderData[0].ProviderSpecialtyType;
                    obj.AdditionalOfferedService = selectedProviderData[0].AdditionalOfferedService;
                    obj.AdditionalOfferedServiceDetail = selectedProviderData[0].AdditionalOfferedServiceDetail;
                    obj.BetterServicesReason = selectedProviderData[0].BetterServicesReason;
                    obj.PatientIssues = selectedProviderData[0].PatientIssues;
                    obj.CustomerWebsite = selectedProviderData[0].CustomerWebsite;
                    obj.OperationalHours = selectedProviderData[0].OperationalHours;
                    obj.InsurancesAccepted = selectedProviderData[0].InsurancesAccepted;
                }

                if (hasRequiredOutboundColumns(leadsArray[0])) {
                    let url = "/api/LeadGenerationUploadLead";
                    let obj = { leadsArray: leadsArray, licenseType: outBoundLeadsDetail, leadsAllowed: leadsAllowed };
                    const userData = await usersPostRequest(token, url, obj);
                    if (userData == "Token is expired, login again") {
                        setIsTokenExpired(true);
                        return
                    }
                    else if (userData && userData.message === "Data inserted successfully!") {
                        setDataSubmitted(true);
                        getUserLicenseDetails(usersPostRequest, token, PracticeId, setIsTokenExpired, setOutBoundLeadsDetail);
                    }
                    else if (userData && userData.message === "You have reached the limit to upload leads on trial") {
                        setDataSubmitted(false);
                        setOutBoundLeadsDetail(userData.message);
                        return
                    }
                    else {
                        setDataSubmitted(false);
                        return
                    }

                } else {
                    alert("Invalid file data")
                    setLoadingEnable(false)
                    document.getElementById("selected_ProviderId").value = "";
                    return
                }
            }
        } catch (error) {
            setLoadingEnable(false);
            alert("Invalid file data");
            document.getElementById("selected_ProviderId").value = "";
        }

    };

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        if (file && providerId) {
            document.getElementById("submitBulkUpload").classList.add("toggleColor");
            e.target.disabled = true;
            // setProviderId("")
            // setFile("")
            const fileType = file.type;
            if (fileType == 'text/csv') {
                await csvFileToArray(file);
            }
            // else if (fileType == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            //     fileReader.onload = async (event) => {
            //         const workbook = XLSX.read(event.target.result, { type: 'binary' });
            //         console.log(workbook)
            //         const sheetName = workbook.SheetNames[0];
            //         console.log(sheetName)
            //     }

            //     fileReader.readAsBinaryString(file);
            // }
        }
    }

    const handleBtns = () => {
        let leadsAllowed = 0;
        let memberListName = currentMemberListName(activeTab);
        leadsAllowed = userType !== "admin" && outBoundLeadsDetail !== undefined && outBoundLeadsDetail.LicenseType !== "subscription" ? outBoundLeadsDetail.LeadsAllowed - parseInt(outBoundLeadsDetail[memberListName]) : "";

        if (file && providerId && outBoundLeadsDetail !== undefined && outBoundLeadsDetail.LicenseType == "trial" && leadsAllowed > 0 && leadsAllowed <= outBoundLeadsDetail.LeadsAllowed && userType !== "admin" || file && providerId && userType === "admin" || file && providerId && outBoundLeadsDetail !== undefined && outBoundLeadsDetail.LicenseType === "subscription") {
            document.getElementById("submitBulkUpload").classList.remove("toggleColor");
            document.getElementById("submitBulkUpload").removeAttribute("disabled");
        }
        else {
            document.getElementById("submitBulkUpload").classList.add("toggleColor");
            document.getElementById("submitBulkUpload").setAttribute("disabled", "true");
        }

        if (providerData.length > 0 && isData === true && leadsAllowed !== "" && leadsAllowed > 0) {
            setLesdsUploadMessage("You can upload only 10 leads on trial in 24 hours!");
            setIsData(false)
        }
        else if (providerData.length === 0 && isData === true) {
            setLesdsUploadMessage("No provider added, Please contact admin to add provider first then you can add/upload leads");
            setIsData(false)
        }
        else if (leadsAllowed <= 0 && leadsAllowed !== "") {
            setLesdsUploadMessage("You have reached the limit to upload leads on trial in 24 hours");
            setIsData(false)
        }
    }

    useEffect(() => {
        handleBtns();
    }, [file, providerId, outBoundLeadsDetail, activeTab, isData]);

    useEffect(() => {
        if (dataSubmitted === true) {
            setLoadingEnable(false)
            alert('Bulk upload process has been completed successfully!')
            setSideBarLinkActive("careConsole")
            setDataSubmitted(false);
        } else {
            setLoadingEnable(false)
            // alert('Bulk upload process not completed!')
        }
    }, [dataSubmitted]);

    // Token-expiry redirect is now handled once, centrally, in ContextApi.js - see its comment
    // for why this component's own copy of the same effect was removed.

    return (
        <>
            <div className="position-relative">
                {loadingEnable === true ?
                    <>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignContent: 'center', position: 'absolute', top: '37%', left: '43%' }}>
                            <CircularProgress />
                        </Box>
                    </> : ""
                }
                <h5 className="my-2 ps-3">Bulk Upload your lead</h5>
                <div className="fileUploader-container p-3 mb-2 rounded-3">
                    <div className="d-flex">
                        <h6 className="p-0 mb-3 col-md-5 col-lg-2">File Uploader </h6>
                        {
                            (userType !== "admin" && outBoundLeadsDetail !== undefined && outBoundLeadsDetail.LicenseType !== "subscription" || providerData.length === 0 && outBoundLeadsDetail !== undefined && outBoundLeadsDetail.LicenseType === "subscription") &&
                            <h6 className="text-center text-danger mb-3 col-md-8 col-lg-9">{lesdsUploadMessage}</h6>
                        }
                    </div>
                    <div className={`fileDrop-container ${loadingEnable === true ? "opacity-75" : ""} text-center rounded-3`}>
                        <div id="dropText" className="my-5">
                            <p className="mb-0">Drop file here or click to select file</p>
                            <p className="mb-0">(allowed: *.CSV, Max size: 200 MB)</p>
                            <input type={"file"} id="csvFileInput" accept={".csv"} onChange={handleOnChange} />
                        </div>
                    </div>
                </div>
                {previewError ? (
                    <p className="text-danger ps-3">{previewError}</p>
                ) : previewColumns.length > 0 ? (
                    <div className="fileUploader-container p-3 mb-2 rounded-3">
                        <h6 className="mb-2">
                            Preview - {previewTotalRows} row{previewTotalRows === 1 ? "" : "s"}, {previewColumns.length} column{previewColumns.length === 1 ? "" : "s"}
                        </h6>
                        {previewMissingColumns.length > 0 ? (
                            <p className="text-danger mb-2">
                                Missing required column{previewMissingColumns.length > 1 ? "s" : ""}: {previewMissingColumns.join(", ")}
                            </p>
                        ) : (
                            <p className="text-success mb-2">All required columns found.</p>
                        )}
                        <div className="table-responsive" style={{ maxHeight: 240, overflow: "auto" }}>
                            <table className="table table-sm table-dark mb-0">
                                <thead>
                                    <tr>
                                        {previewColumns.map((col) => <th key={col}>{col}</th>)}
                                    </tr>
                                </thead>
                                <tbody>
                                    {previewRows.map((row, idx) => (
                                        <tr key={idx}>
                                            {previewColumns.map((col) => <td key={col}>{String(row[col] ?? "")}</td>)}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {previewTotalRows > previewRows.length && (
                            <p className="text-muted mb-0 mt-1">Showing first {previewRows.length} of {previewTotalRows} rows.</p>
                        )}
                    </div>
                ) : null}
                <div className="d-flex justify-content-start align-item-center position-relative dropdownProvider ps-3 mb-2">
                    <select className="form-select text-white me-2" id="selected_ProviderId" onChange={(e) => setProviderId(e.target.value)}>
                        <option className="selectedProviderOption" value="">Select Provider</option>
                        {
                            providerData.length > 0 ?
                                providerData.map((provider) => {
                                    return (
                                        <option key={provider.Id} className="selectedProviderOption" value={provider.Id}>{provider.ProviderName}</option>
                                    );
                                })
                                : ""
                        }
                    </select>
                    <span>
                        {/* <FontAwesomeIcon className="position-absolute caretDown" id="caretDown" icon={faCaretDown}/> */}
                    </span>
                    <div className="parentBtn">
                        <button className="submitButton simple-btn" id="submitBulkUpload" onClick={handleOnSubmit}>Process Bulk Upload Lead</button>
                    </div>
                </div>
                <div className="ps-3">
                    <h6 className="mb-0">Don't have a CSV?</h6>
                    <p className="mb-2">Use our template to create one.
                        {
                            activeTab == "pAuthQTab" ?
                                <a href={PriorAuthQBulkUploadLead} download="PriorAuthQBulkUploadLead.csv">Click here</a>
                                : <a href={LeadGenerationBulkUploadLead} download="LeadGenerationBulkUploadLead.csv">Click here</a>
                        }
                        to download it.
                    </p>
                </div>
            </div>
        </>
    )
}
